import { createReducer } from "@reduxjs/toolkit";
import {
  storeSelectedQuestionData,
  storeParentQuestionsArray,
  storeParentQuestionsArrayWithId,
  storeQuestionLanguagesForQuestion,
  storeSelectedbucket,
  storeBucketIdsForQuestion,
  storeIsEditContent,
  storeIsShow,
  storeScenariostate,
  storeIsDirty,
  storeQuestionFilter,
  storeQuestionPagination,
  storeSelectedTag,
  StoreSubtypeEnabledInFilter,
  storeComments,
  storeIsExpanded,
  storeIsQuestionCloneOpen,
} from "redux/action/questionAction";
const INITIAL_STATE = {
  questionData: {},
  parentQuestionList: [],
  parentQuestionListWithId: [],
  questionLanguagesForQuestion: [],
  selectedbucket: [],
  bucketIdsForQuestion: [],
  isEditContent: true,
  isShow: true,
  scenariostate: [],
  isDirty: false,
  questionFilter: {},
  quesPagination: null,
  selectedNode: {},
  subType: true,
  comments: [],
  isExpanded: false,
  isQuestionCloneOpen: false,
};
const questionReducer = createReducer(INITIAL_STATE, (builder) => {
  builder.addCase(storeParentQuestionsArray, (state, action) => {
    const payload = action.payload;
    return { ...state, parentQuestionList: [...payload] };
  });
  builder.addCase(storeSelectedQuestionData, (state, action) => {
    const payload = action.payload;
    return {
      ...state,
      questionData: {
        ...payload,
      },
    };
  });
  builder
    .addCase(storeQuestionPagination, (state, action) => {
      const payload = action.payload;
      return { ...state, quesPagination: payload };
    })
    .addCase(storeParentQuestionsArrayWithId, (state, action) => {
      const payload = action.payload;
      return { ...state, parentQuestionListWithId: [...payload] };
    })
    .addCase(storeQuestionLanguagesForQuestion, (state, action) => {
      const payload = action.payload;
      return { ...state, questionLanguagesForQuestion: [...payload] };
    })
    .addCase(storeSelectedbucket, (state, action) => {
      const payload = action.payload;
      return { ...state, selectedbucket: [...payload] };
    })
    .addCase(storeBucketIdsForQuestion, (state, action) => {
      const payload = action.payload;
      return { ...state, bucketIdsForQuestion: [...payload] };
    })
    .addCase(storeIsEditContent, (state, action) => {
      const payload = action.payload;
      return { ...state, isEditContent: payload };
    })
    .addCase(storeIsShow, (state, action) => {
      const payload = action.payload;
      return { ...state, isShow: payload };
    })
    .addCase(storeScenariostate, (state, action) => {
      const payload = action.payload;
      return { ...state, scenariostate: [...payload] };
    })
    .addCase(storeIsDirty, (state, action) => {
      const payload = action.payload;
      return { ...state, isDirty: payload };
    })
    .addCase(storeComments, (state, action) => {
      const payload = action.payload;
      return { ...state, comments: [...payload] };
    })
    .addCase(storeIsExpanded, (state, action) => {
      const payload = action.payload;
      return { ...state, isExpanded: payload };
    })
    .addCase(storeIsQuestionCloneOpen, (state, action) => {
      const payload = action.payload;
      return { ...state, isQuestionCloneOpen: payload };
    });
  builder.addCase(storeQuestionFilter, (state, action) => {
    const payload = action.payload;
    return {
      ...state,
      questionFilter: {
        ...payload,
      },
    };
  });
  builder.addCase(storeSelectedTag, (state, action) => {
    const payload = action.payload;
    return {
      ...state,
      selectedNode: {
        ...payload,
      },
    };
  });
  builder.addCase(StoreSubtypeEnabledInFilter, (state, action) => {
    const payload = action.payload;
    return { ...state, subType: payload };
  });
});
export default questionReducer;
